import { render, staticRenderFns } from "./deleteFee.vue?vue&type=template&id=39b499c5"
import script from "./deleteFee.vue?vue&type=script&lang=js"
export * from "./deleteFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports